import React from 'react'
import Image from './Image'
import Video from './Video'

const Media = ({ type, ...props }) => {
  return type === 'image' ? <Image {...props} /> : <Video {...props} />
}

export default Media
